import { useEffect, useRef, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { api } from "@/lib/api";
import { useLang } from "@/lib/i18n";
import { useConfig } from "@/lib/auth";
import { captureUtm, track } from "@/lib/track";
import { VehicleGrid } from "@/components/xd/VehicleCard";
import { SimilarRequest } from "@/components/xd/SimilarRequest";
import { Empty, Loader, Logo } from "@/components/xd/ui";

export function Sold() {
  const { t } = useLang();
  const [items, setItems] = useState(null);
  useEffect(() => {
    api.get("/public/sold").then((r) => setItems(r.data.items)).catch(() => setItems([]));
  }, []);
  return (
    <div className="mx-auto max-w-7xl px-4 md:px-8 py-10 md:py-16" data-testid="sold-page">
      <p className="eyebrow">{t("sold.eyebrow")}</p>
      <h1 className="mt-3 mb-3 text-4xl sm:text-5xl font-semibold tracking-tight chrome-text">{t("nav.sold")}</h1>
      <p className="text-zinc-400 mb-8 text-sm">{t("sold.subtitle")}</p>
      {!items ? <Loader /> : items.length ? <VehicleGrid items={items} priceLabel={t("vehicle.last_price")} footerFor={(v) => <SimilarRequest v={v} />} /> : <Empty text={t("sold.empty")} />}
    </div>
  );
}

export function Referral() {
  const { uid, code } = useParams();
  const navigate = useNavigate();
  const sent = useRef(false);
  useEffect(() => {
    if (sent.current) { return; }
    sent.current = true;
    captureUtm();
    track("referral", { broker_uid: uid }).finally(() => navigate(code ? `/vehicle/${code}` : "/", { replace: true }));
  }, [uid, code, navigate]);
  return <div className="min-h-screen grid place-items-center bg-black"><Logo className="h-24 animate-pulse" testid="referral-logo" /></div>;
}

export function ContentPage() {
  const { key } = useParams();
  const { t, lang } = useLang();
  const { content } = useConfig();
  const text = content[key]?.[lang];
  return (
    <div className="mx-auto max-w-3xl px-6 py-16" data-testid={`content-page-${key}`}>
      <h1 className="text-3xl md:text-4xl font-semibold chrome-text mb-8">{t(`page.${key}`)}</h1>
      {text === undefined ? <Loader /> : <p className="text-zinc-300 leading-relaxed whitespace-pre-line">{text}</p>}
    </div>
  );
}
